const PrivacyPolicy = () => {
    return (
        <div>
            <h1>Privacy Policy</h1>
            <p>Here you can put your privacy policy content.</p>
        </div>
    );
};

export default PrivacyPolicy;